import { useState } from 'react';
import { useTableFacetContext } from 'modules/experiments/contexts';
import { SEARCH_TEXT_INPUT_DEBOUNCE_TIMEOUT_MS } from 'modules/experiments/constants';
import { useExperimentsTranslations } from 'modules/experiments/hooks';
import { useDebouncedEffect } from 'utils/hooks/useDebouncedEffect';
import { SearchText } from './Styled';

export const FreeFormSearch = () => {
  const { t } = useExperimentsTranslations();
  const { search, setSearch } = useTableFacetContext();
  const [localSearch, setLocalSearch] = useState(search);

  /**
   * Debouncing the search input. So, that we don't keep querying
   * the backend for every input change.
   */
  useDebouncedEffect(() => setSearch(localSearch), [localSearch], {
    skipEffectOnMount: true,
    debounceTimeout: SEARCH_TEXT_INPUT_DEBOUNCE_TIMEOUT_MS,
  });

  return (
    <SearchText
      id="experiments-index-search-input"
      data-test="experiments-index-search-input"
      placeholder={t('placeholder.searchExperiments')}
      onChange={setLocalSearch}
      value={localSearch}
    />
  );
};
